import React, { useContext, useEffect } from 'react';
import Login from './Login';
import Representation from './representation/Representation';
import { StateContext } from '../State';
import { Message, useMessageGetter } from '@messageformat/react';
import Header from './Header';
import Footer from './Footer';
import loadingIndicator from '../loadingIndicator';
import { ScreenReaderOnly, StatusMessage } from '@op/opds.opux';
import { Mode, RepMode, LoginType, LoginUiPhase, loginContainerId, representationContainerId, fullpageloginContainerId } from '../constants';
import '../css/fullpagelogin.scss';
import { ModelContext } from '../ModelContext';
import LanguageChangeNotification from './LanguageChangeNotification';

const Fullpagelogin = (props) => {
    const state = useContext(StateContext);
    const msg = useMessageGetter('fp');
    const { model } = useContext(ModelContext);
    const serviceName = useMessageGetter()('fp.serviceName');

    useEffect(() => {
        /* We set loading indicator according to current state */
        /* Loading indicator itself is separated from React state, so it can be started and stopped without triggering React render when necessary. */
        const loginLoading = state.mode === Mode.LOGIN && !state.errorCode && state.authType !== null && state.loginUiPhase !== LoginUiPhase.VERIFY;
        const repLoading = state.mode === Mode.REP && state.repMode !== RepMode.LIST && !state.errorCode;
        const loading = loginLoading || repLoading;
        loadingIndicator.set(loading, loginLoading);
    });

    const renderLoginComponent = model.loginType === LoginType.OPLOGIN && (state.mode === Mode.LOGIN || state.errorCode);
    const renderRepresentationComponent = !renderLoginComponent;
    const mainContentElementId = renderLoginComponent ? loginContainerId : representationContainerId;
    const renderScreenReaderOnlyInstruction = state.loginUiPhase !== LoginUiPhase.VERIFY;

    let welcomeMessage = '';
    if (state.mode === Mode.LOGIN) {
        welcomeMessage = msg('accessibility.welcomeMessage.other');
    }

    return (
        <>
            <Header mainContentElementId={mainContentElementId} />
            <div id={fullpageloginContainerId} role='main'>
                <h1 id='service-title' className='fullpagelogin-mobile-service-title-visible service-title-text opux-v6__opds'>
                    {serviceName}
                </h1>
                {renderScreenReaderOnlyInstruction && <ScreenReaderOnly>{welcomeMessage}</ScreenReaderOnly>}
                {state.statusMessage && (
                    <StatusMessage hidden delay='800'>
                        {state.statusMessage}
                    </StatusMessage>
                )}
                {renderLoginComponent && <Login />}
                {renderRepresentationComponent && <Representation />}
            </div>
            <Footer />
            {/* Keep loading indicator description here instead of pre-rendered LoadingIndicator component, this way we can use localization. */}
            <div id='loading-indicator-description' style={{ display: 'none' }}>
                <Message id='fp.accessibility.loading' />
            </div>
            <LanguageChangeNotification />
        </>
    );
};

export default Fullpagelogin;
